module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-page"
  }, [_c('div', {
    staticClass: "header"
  }, [(_vm.avatar) ? _c('img', {
    attrs: {
      "src": _vm.avatar
    }
  }) : _c('div', {
    staticClass: "placeholder"
  }, [_vm._v(_vm._s(_vm.userInfo.name && _vm.userInfo.name.charAt(0).toUpperCase()))]), _c('h3', [_vm._v(_vm._s(_vm.userInfo.name && _vm.userInfo.name))])]), _c('div', {
    staticClass: "main"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path
    }
  }, _vm._l((_vm.menus), function(menu, index) {
    return _c('el-menu-item', {
      key: index,
      class: {
        'active': _vm.$route.path === menu.path
      },
      attrs: {
        "index": menu.path
      },
      nativeOn: {
        "click": function($event) {
          return _vm.onPage(menu.path)
        }
      }
    }, [_c('i', {
      class: menu.icon
    }), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(menu.title))])])
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-390defce","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBar.vue
// module id = 568
// module chunks = 85